import React from "react";
import PersonnelIcon from "../../assets/icons/personnel-icon.svg";
import GraduateIcon from "../../assets/icons/graduate-icon.svg";
import StateIcon from "../../assets/icons/state-icon.svg";
import ResearchIcon from "../../assets/icons/research-icon.svg";
import TeamIcon from "../../assets/icons/team-icon.svg";
import {
  ImpactSection,
  SectionHeading,
  SectionSubtitle,
  CardsRow,
  StatCard,
  CardIcon,
  StatNumber,
  StatLabel,
  cardColors
} from "./styled.components";

const cards = [
  {
    icon: PersonnelIcon,
    color: cardColors.purple,
    stat: "10,000+",
    label: "Trained Personnel Nationwide"
  },
  {
    icon: GraduateIcon,
    color: cardColors.darkBlue,
    stat: "600,000+",
    label: "Estimated Arizona Students Protected"
  },
  {
    icon: StateIcon,
    color: cardColors.lightBlue,
    stat: "Statewide Reach",
    label: "Across Arizona Schools"
  },
  {
    icon: ResearchIcon,
    color: cardColors.green,
    stat: "Research-Informed",
    label: "Expert-Reviewed Training Resources"
  },
  {
    icon: TeamIcon,
    color: cardColors.yellow,
    stat: "70+",
    label: "Future Public Health Leaders Mentored"
  }
];

interface OurImpactProps {
  heading: string;
  subtitle: string;
  variant?: "default" | "flat";
}

const OurImpact: React.FC<OurImpactProps> = ({
  heading,
  subtitle,
  variant
}) => (
  <ImpactSection $variant={variant}>
    <SectionHeading>{heading}</SectionHeading>
    <SectionSubtitle>{subtitle}</SectionSubtitle>
    <CardsRow>
      {cards.map((card, i) => (
        <StatCard key={i} $variant={variant}>
          <CardIcon color={card.color}>
            <img src={card.icon} alt="" />
          </CardIcon>
          <StatNumber color={card.color}>{card.stat}</StatNumber>
          <StatLabel>{card.label}</StatLabel>
        </StatCard>
      ))}
    </CardsRow>
  </ImpactSection>
);

export default OurImpact;
